import { PROFILE_ROUTE } from '../constants/GolferProfileConstants';

interface RoutePermission {
    route: string;
    permission: string;
    priority: number; // Lower number = higher priority
  }
  
  export const routePermissionMap: RoutePermission[] = [
    {
      route: '/admin/dashboard',
      permission: 'Main.Dashboard.View',
      priority: 1,
    },
    {
      route: '/admin/members',
      permission: 'Member.Members.View',
      priority: 2,
    },
    {
      route: '/admin/bulkemails',
      permission: 'Communication.BulkEmails.View',
      priority: 3,
    },
    {
      route: '/admin/users',
      permission: 'Settings.Administrators.View',
      priority: 4,
    },
    {
      route: '/admin/auditlogs',
      permission: 'Settings.AuditLog.View',
      priority: 5,
    },
    {
      route: '/admin/companyinfo',
      permission: 'Settings.CompanyInfo.View',
      priority: 6,
    },
  ];
  
  export const getFirstAvailableRoute = (
    userPermissions: string[],
    userRoles: string[] | null = null,
  ): string => {
    const availableRoute = routePermissionMap
      .sort((a, b) => a.priority - b.priority) // Sort by priority
      .find(route => userPermissions.includes(route.permission));

    if (availableRoute) {
      return availableRoute.route;
    }

    // No admin permission matched — a plain member (role "User", no admin permissions) still
    // needs a landing page instead of falling through to /login. That is their profile, not the
    // member dashboard, which is for admins only (see the member group in Sidebar).
    if (userRoles?.includes('User')) {
      return PROFILE_ROUTE;
    }

    return '/login'; // Fallback to login if nothing matched
  };